import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticatedGuard, UnsavedChangesGuard } from 'routes/routes.guard';
import { RoutePaths, RouteRoles } from './route.roles';

const routes: Routes = [
    {
        path: RoutePaths.Offline,
        loadChildren: () => import('../modules/offline/offline.module').then((m) => m.OfflineModule),
    },
    {
        path: RoutePaths.Classlink,
        loadChildren: () => import('../modules/classlink/classlink.module').then((m) => m.ClasslinkModule),
    },
    {
        path: RoutePaths.Login,
        loadChildren: () => import('../modules/login/login.module').then((m) => m.LoginModule),
    },
    {
        path: RoutePaths.Home,
        loadChildren: () => import('../modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.Home },
    },
    {
        path: RoutePaths.NewVisit,
        loadChildren: () => import('../modules/newvisit/newvisit.module').then((m) => m.NewVisitModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.NewVisit },
    },
    {
        path: RoutePaths.MyVisits,
        loadChildren: () => import('../modules/myvisits/myvisits.module').then((m) => m.MyVisitsModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.MyVisits },
    },
    {
        path: RoutePaths.ViewVisit,
        loadChildren: () => import('../modules/viewvisit/viewvisit.module').then((m) => m.ViewVisitModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.ViewVisit },
    },
    {
        path: RoutePaths.SIPEditor,
        loadChildren: () => import('../modules/sipeditor/sipeditor.module').then((m) => m.SIPEditorModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.SIPEditor },
    },
    {
        path: RoutePaths.UsersEditor,
        loadChildren: () => import('../modules/userseditor/userseditor.module').then((m) => m.UsersEditorModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.UsersEditor },
    },
    {
        path: RoutePaths.VisitSearch,
        loadChildren: () => import('../modules/visitsearch/visitsearch.module').then((m) => m.VisitSearchModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.VisitSearch },
    },
    {
        path: RoutePaths.ContentAreaEditor,
        loadChildren: () => import('../modules/contentareaeditor/contentareaeditor.module').then((m) => m.ContentAreaEditorModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.ContentAreaEditor },
    },
    {
        path: RoutePaths.Reports,
        loadChildren: () => import('../modules/reports/reports.module').then((m) => m.ReportsModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.Reports },
    },
    {
        path: RoutePaths.ViewGoals,
        loadChildren: () => import('../modules/viewgoals/viewgoals.module').then((m) => m.ViewGoalsModule),
        canActivate: [AuthenticatedGuard],
        data: { Roles: RouteRoles.ViewGoals },
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
